import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import styles from "./related-reviews.module.css";
import sharedStyles from "../../car-reviews-v2.module.css";
import { StarRating } from "../star-rating";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
export var formattedHref = function(url) {
    return url.replace(/car-reviews-v2/g, "/used-cars");
};
export var RelatedReviews = function(param) {
    var items = param.items, make = param.make, model = param.model;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function(currentMake, currentModel, suggestedVehicleReview) {
        var suggestedMakeAndModel = suggestedVehicleReview.replace(/\w+[!.?]?$/, "").toLocaleLowerCase();
        trackEvent({
            eventName: "similar reviews - from ".concat(make, " ").concat(model),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "similar reviews",
                    label: "from ".concat(currentMake, " ").concat(currentModel),
                    action: "to ".concat(suggestedMakeAndModel)
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: sharedStyles.inner,
        children: [
            /*#__PURE__*/ _jsxs(Heading, {
                element: "h2",
                fontSize: "h3",
                children: [
                    "Similar to the",
                    " ",
                    /*#__PURE__*/ _jsxs("span", {
                        className: styles.capitalise,
                        children: [
                            make,
                            " ",
                            model
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: styles.relatedItem,
                        onClick: function() {
                            return window.location.assign(formattedHref(item.full_slug));
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.relatedImgWrapper,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: styles.relatedImgBorder,
                                    children: /*#__PURE__*/ _jsx("img", {
                                        className: styles.relatedImg,
                                        alt: "".concat(make, " ").concat(model),
                                        src: item.image || "".concat(process.env["STAGE_NAME"] === "local" ? "" : process.env.STAGE_URL, "/image-coming-soon.svg")
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.relatedContentWrapper,
                                children: [
                                    /*#__PURE__*/ _jsx(Heading, {
                                        element: "h3",
                                        className: styles.relatedTitle,
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.relatedStars,
                                        children: /*#__PURE__*/ _jsx(StarRating, {
                                            starRating: Number(item.starRating)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: styles.relatedSnippet,
                                        children: item.snippet
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: formattedHref(item.full_slug),
                                        className: styles.relatedLink,
                                        onClick: function() {
                                            return handleClick(make, model, item.title);
                                        },
                                        children: "Read more"
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
